// extracted by mini-css-extract-plugin
module.exports = {"demoCardWrapper":"styles_demoCardWrapper__n9ITF","backgroundGradientWrapper":"styles_backgroundGradientWrapper__JX81_","newLine":"styles_newLine__ulhM8"};